module.exports = __webpack_public_path__ + "img/mapFootBg.1cefadea.png";